export default "This will reset Bar Regulation settings to\nfactory default values."